<template>
  <div class="keycaseVideo">
    <div class="header">
      <div class="header-title" >
        <div style="display: contents;" v-html="subjectChoose.Name"></div>
        <!-- {{ subjectChoose.Name }} -->
        <span class="select-km" @click="switchSubject"
          >切换科目{{ switchs }}</span
        >
        <span class="dowload" @click="dowload"> {{ this.Jump }}</span>
      </div>

      <!-- {{subjectChoose.Name.lastIndexOf("(")==-1?subjectChoose.Name: subjectChoose.Name.substr(0,subjectChoose.Name.lastIndexOf("(")) }} -->
    </div>

    <el-main>
      <div class="ww">
        <div class="video">
          <div class="prism-player" id="J_prismPlayer"></div>
        </div>
        <!-- 右边视频列表 -->
        <div class="right">
          <div class="navList">
            <ul>
              <li
                v-for="(navItem, navIndex) in navList"
                :class="switchs == navItem.id ? 'aaaa' : ''"
                @click="onSwitchs(navItem)"
                :key="navIndex"
              >
                {{ navItem.name }}
              </li>
            </ul>
          </div>
          <!-- 视频列表 -->
          <div class="videolist" v-if="switchs == 1">
            <!-- <videolist ref="videolist"></videolist> -->
            <div class="list-left">
              <div
                class="list-title"
                v-for="(item, index) in videoList"
                :class="item.open ? 'title' : ''"
                @click="onList(item.bookID, index)"
              >
                {{
                  item.bookName.lastIndexOf("_") == -1
                    ? item.bookName
                    : item.bookName.substr(0, item.bookName.lastIndexOf("_"))
                }}
              </div>
            </div>
            <div class="list-right">
              <div
                class="list-kecheng"
                v-for="(items, indexs) in booklistArray"
                :class="items.opens ? 'kecheng' : ''"
                @click="onPlayer(items, indexs)"
              >
                {{ items.summary }}
                <span
                  v-if="items.type == 0"
                  :class="items.opens ? 'kecheng-mianfei' : 'aa'"
                  class="mianfei"
                  >免费</span
                >
                <span
                  ><img
                    class="bofang"
                    src="../assets/five_bofang.gif"
                    v-show="items.opens"
                /></span>
              </div>
              <!-- 	<div class="list-kecheng" v-for="(items,indexs) in booklistArray" 
				v-show="index==0"
				 :class="activek==0?'kecheng':''" @click="onPlayer(items,indexs)">
					{{items.summary}} <span v-if="items.type==0" :class="activek==indexs?'kecheng-mianfei':'aa'" class="mianfei">免费</span>
				</div> -->
            </div>

            <div class="gengduo" @click="gengduo = true">查看更多课程</div>
          </div>
          <div class="xiangjie" v-if="switchs == 2">
            <div style="padding: 20px" v-if="knowledgeText == ''">
              暂无考点详情
            </div>
            <div v-else class="knowledgeText" v-html="knowledgeText"></div>
          </div>
          <div class="lxls" v-if="switchs == 3">
            <contactTeacher ref="contactTeacher"> </contactTeacher>
          </div>
        </div>
      </div>
      <!-- 老师介绍，老师介绍 -->
      <div class="footer">
        <div class="navList-footer">
          <ul>
            <li
              v-for="(nav_Item, nav_Index) in navfooter"
              :class="switchd == nav_Item.id ? 'actived' : ''"
              @click="onSwitch(nav_Item)"
              :key="nav_Index"
            >
              {{ nav_Item.name }}
            </li>
          </ul>
        </div>
        <div
          class="teacher_js"
          v-if="
            switchd == 1 &&
            (KsbClassID == 180 ||
              KsbClassID == 181 ||
              KsbClassID == 182 ||
              KsbClassID == 183 ||
              KsbClassID == 184 ||
              KsbClassID == 184 ||
              KsbClassID == 185 ||
              KsbClassID == 186 ||
              KsbClassID == 187 ||
              KsbClassID == 188 ||
              KsbClassID == 189 ||
              KsbClassID == 190 ||
              KsbClassID == 191 ||
              KsbClassID == 192 ||
              KsbClassID == 193 ||
              KsbClassID == 194 ||
              KsbClassID == 195 ||
              KsbClassID == 196)
          "
        >
          <div class="eerr"><img src="../assets/img/gjzc.jpeg" /></div>
        </div>
        <div
          class="teacher_js"
          v-if="
            switchd == 1 &&
            (KsbClassID == 197 ||
              KsbClassID == 198 ||
              KsbClassID == 199 ||
              KsbClassID == 200 ||
              KsbClassID == 201)
          "
        >
          <div class="eerr"><img src="../assets/img/czj.png" /></div>
        </div>
        <div
          class="teacher_js"
          v-if="
            switchd == 1 &&
            (KsbClassID == 202 || KsbClassID == 203 || KsbClassID == 204)
          "
        >
          <div class="eerr"><img src="../assets/img/czj.png" /></div>
        </div>

        <div class="teacher_js" v-if="switchd == 1 && KsbClassID == 206">
          <div class="eerr"><img src="../assets/img/zyyis.jpg" /></div>
        </div>

        <div
          class="teacher_js"
          v-if="switchd == 1 && (KsbClassID == 375 || KsbClassID == 374)"
        >
          <div class="eerr"><img src="../assets/img/zyyaos.jpg" /></div>
        </div>

        <div
          class="teacher_js"
          v-if="
            switchs == 1 &&
            (KsbClassID == 377 ||
              KsbClassID == 378 ||
              KsbClassID == 379 ||
              KsbClassID == 380 ||
              KsbClassID == 381 ||
              KsbClassID == 382 ||
              KsbClassID == 383)
          "
        >
          <div><img class="eerr" src="../assets/img/ylzp.jpg" /></div>
        </div>

        <div
          class="teacher_js"
          v-if="
            switchd == 1 &&
            (KsbClassID == 154 ||
              KsbClassID == 206 ||
              KsbClassID == 375 ||
              KsbClassID == 374)
          "
        >
          <div class="eerr"><img src="../assets/img/zyhs.png" /></div>
        </div>
        <!-- <div class="teacher-content" v-for="(teacheItem, teacherIndex) in teacherList" :key="teacherIndex">
					<div class="guid-content">
						<div class="guid-content-left">
							<img :src="teacheItem.teacherImage" class="guid-content-left-img" />
						</div>
						<div class="guid-content-right">
							<div class="guid-content-right-title">
								{{ teacheItem.teacherName }}
							</div>
				
						</div>
					</div>
					<div class="guid-content-right-text">
						{{ teacheItem.teacherInfo }}
					</div>
				</div> -->
        <div class="shipinfankui" v-if="switchd == 2">
          <div class="feedback">
            <div class="neirong">
              <ul class="typeList">
                <li
                  v-for="(typeListItem, typeListIndex) in typeList"
                  :class="typeListItem.open ? 'ac' : ''"
                  @click="onTypeList(typeListIndex, typeListItem.id)"
                  :key="typeListIndex"
                >
                  {{ typeListItem.name }}
                </li>
              </ul>
            </div>
            <!--  -->
            <textarea
              placeholder="请输入反馈内容"
              v-model="feedbackContent"
              class="textarea"
            />
            <div class="btn">
              <div class="tijiao" @click="onSubmit">提交</div>
            </div>
          </div>
        </div>
      </div>
    </el-main>

    <div class="fankui">
      <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="18%"
        center
      >
        <span>感谢您的反馈，我们会尽快核实并给你答复</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <el-dialog :visible.sync="subjectzz" width="50%">
      <div class="zzzzz">
        <subject @subjects="onSubject"></subject>
      </div>
    </el-dialog>
    <div class="login">
      <el-dialog
        title="快速登录注册"
        :visible.sync="gengduo"
        width="30%"
        center
      >
        <login @login="denglu"></login>
      </el-dialog>
    </div>
  </div>
</template>

<script>
var that;
import { videoPlayer } from "vue-video-player";
import contactTeacher from "../components/contactTeacher.vue";
import videoFeedback from "../components/videoFeedback.vue";
import subject from "../components/subject.vue";
import login from "../components/login.vue";
import {
  insertBuriedPoint,
  videoCatalogue,
  videoPlayUrl,
  getAgentInfo,
  getVideoCount,
  selectAgent,
  getteacherlist,
  freeCourse,
  freeCourse2,
  AddNews,
} from "../api/api.js";
export default {
  data() {
    return {
      Jump: "下载考试宝典",
      KsbClassID: "",
      navList: [
        {
          id: 1,
          name: "视频列表",
        },
        {
          id: 2,
          name: "考点详解",
        },
        {
          id: 3,
          name: "联系老师",
        },
      ],
      navfooter: [
        {
          id: 1,
          name: "班次介绍",
        },
        {
          id: 2,
          name: "视频反馈",
        },
      ],
      typeList: [
        {
          open: false,
          id: 21,
          name: "老师讲解问题",
        },
        {
          open: false,
          id: 22,
          name: "视频与大纲不符",
        },
        {
          open: false,
          id: 23,
          name: "视频音量问题",
        },
        {
          open: false,
          id: 24,
          name: "视频内容与其科目不符",
        },
        {
          open: false,
          id: 25,
          name: "考点详解图片不显示",
        },
        {
          open: false,
          id: 27,
          name: "专项练习问题",
        },
        {
          open: false,
          id: 26,
          name: "其他问题",
        },
      ],
      phone: "",
      errorType: [],
      feedbackContent: "",
      subjectChoose: {},
      slbs: "",
      switchs: 1, //切换
      switchd: 1,
      videoList: [],
      guid: "",
      booklistArray: [],
      activet: 0,
      activek: 100,
      knowledgeText: "",
      teacherList: [],
      feedbackItem: "",
      centerDialogVisible: false,
      subjectzz: false,
      gengduo: false,
      firstlist: [],
      bf: "",
      slbs2: "",
    };
  },
  components: {
    contactTeacher,
    videoFeedback,
    subject,
    login,
  },
  created() {

  if (!JSON.parse(localStorage.getItem("loginData"))) {
      localStorage.setItem(
        "loginData",
        JSON.stringify({
          guid: "YI7aLMsKobFIWBd5jkW43xZVoFtBIIWp504278861",
          userID: "504278861",
          userName: "游客",
        })
      );
      that.guid = "YI7aLMsKobFIWBd5jkW43xZVoFtBIIWp504278861";
    }


    //非选择科目进来的，会在路由参数上带合作商和渠道信息，需要重新获取老师信息并保存到缓存
    if (this.$route.params.slbs || this.$route.params.slbs2) {
      this.slbs = this.$route.params.slbs;
      this.slbs2 = this.$route.params.slbs2;
      this.notSelectKeMu();
    }

if(JSON.parse(localStorage.getItem("loginData"))){

    this.guid = JSON.parse(localStorage.getItem("loginData")).guid;
}
    var locSlbs = localStorage.getItem("slbs2");
    this.slbs2 = "";
    if (locSlbs != "undefined") {
      this.slbs2 = locSlbs;
    }
    // console.log("this.$route.query.item",JSON.parse(sessionStorage.getItem('subjectChoose')).AppID)
    if (this.$route.query.code == "subjectChoose") {
      sessionStorage.setItem("subjectChoose", this.$route.query.item);
      this.subjectChoose = JSON.parse(sessionStorage.getItem("subjectChoose")); //接收选科目传过来值
    } else {
      this.subjectChoose = JSON.parse(sessionStorage.getItem("subjectChoose")); //接收选科目传过来值
    }
    // this.onSwitchsData();
  },
  mounted() {
    that = this;
    that.onSwitchsData();
    if (localStorage.getItem("agent") === "undefined") {
      console.log("由于系统无法找到该代理商信息");
    } else {
      that.slbs = JSON.parse(localStorage.getItem("agent"))?JSON.parse(localStorage.getItem("agent")).slbs:'';
    }

    if (
      this.slbs == "100176-1" ||
      this.slbs == "101417-1" ||
      this.slbs == "100088-1" ||
      this.slbs == "300128-1" ||
      this.slbs == "100006-1" ||
      this.slbs == "101226-2" ||
      this.slbs == "100521-1" ||
      this.slbs == "043129" ||
      this.slbs == "100748-1" ||
      this.slbs == "100052-1" ||
      this.slbs == "075901" ||
      this.slbs == "100079-1" ||
      this.slbs == "300100-1" ||
      this.slbs == "300251-1" ||
      this.slbs == "300112-1" ||
      this.slbs == "100660-2" ||
      this.slbs == "037510" ||
      this.slbs == "300089-1" ||
      this.slbs == "047211" ||
      this.slbs == "059601" ||
      this.slbs == "079108" ||
      this.slbs == "085104" ||
      this.slbs == "055618" ||
      this.slbs == "085201" ||
      this.slbs == "077512" ||
      this.slbs == "300051-1" ||
      this.slbs == "300081-1" ||
      this.slbs == "024009" ||
      this.slbs == "073103" ||
      this.slbs == "045207" ||
      this.slbs == "100888-1" ||
      this.slbs == "100401-1" ||
      this.slbs == "100329-1" ||
      this.slbs == "100889-1" ||
      this.slbs == "043504" ||
      this.slbs == "0209001" ||
      this.slbs == "037509" ||
      this.slbs == "101311-1" ||
      this.slbs == "300115-1" ||
      this.slbs == "300265-1" ||
      this.slbs == "200004-1" ||
      this.slbs == "300239-1" ||
      this.slbs == "300049-1" ||
      this.slbs == "023023" ||
      this.slbs == "020090" ||
      this.slbs == "100647-1" ||
      this.slbs == "100274-1 " ||
      this.slbs == "101312-1" ||
      this.slbs == "100531-1" ||
      this.slbs == "100018-1" ||
      this.slbs == "100033-1" ||
      this.slbs == "100033-2" ||
      this.slbs == "100167-1" ||
      this.slbs == "100016-1" ||
      this.slbs == "100398-1" ||
      this.slbs == "101262-1" ||
      this.slbs == "101270-1" ||
      this.slbs == "100905-1" ||
      this.slbs == "101473-1" ||
      this.slbs == "100915-1" ||
      this.slbs == "101472-1" ||
      this.slbs == "100922-1" ||
      this.slbs == "101480-1" ||
      this.slbs == "101624-1" ||
      this.slbs == "101492-1" ||
      this.slbs == "101466-1" ||
      this.slbs == "101471-1" ||
      this.slbs == "101616-1" ||
      this.slbs == "101620-1" ||
      this.slbs == "101622-1" ||
      this.slbs == "101632-1" ||
      this.slbs == "101628-1" ||
      this.slbs == "668002" ||
      this.slbs == "101485-1" ||
      this.slbs == "101466-2" ||
      this.slbs == "101617-1" ||
      this.slbs == "101618-1" ||
      this.slbs == "020010-1" ||
      this.slbs == "101082-1" ||
      this.slbs == "039406" ||
      this.slbs == "100966-1" ||
      this.slbs == "100898-1 " ||
      this.slbs == "300182-1" ||
      this.slbs == "300116-1" ||
      this.slbs == "300111-1" ||
      this.slbs == "300096-2 " ||
      this.slbs == "07719001" ||
      this.slbs == "04789001" ||
      this.slbs == "0209001" ||
      this.slbs == "03719002" ||
      this.slbs == "05759001" ||
      that.slbs == "100748-1-1" ||
      that.slbs == "100748-1-2" ||
      that.slbs == "100176-1" ||
      that.slbs == "100052-1" ||
      that.slbs == "100006-1" ||
      that.slbs == "100401-1" ||
      that.slbs == "100888-1" ||
      that.slbs == "020087" ||
      this.slbs == "300100-1" ||
      this.slbs == "300112-1" ||
      this.slbs == "100079-1" ||
      this.slbs == "300239-1" ||
      this.slbs == "100660-2" ||
      this.slbs == "037510" ||
      this.slbs == "300128-1" ||
      this.slbs == "300251-1" ||
      this.slbs == "300081-1" ||
      this.slbs == "075901" ||
      this.slbs == "047211" ||
      this.slbs == "059601" ||
      this.slbs == "079108" ||
      this.slbs == "085104" ||
      this.slbs == "055618" ||
      this.slbs == "085201" ||
      (this.slbs == "077512" && this.slbs2 == "1") ||
      this.slbs2 == "2"
    ) {
      that.Jump = "在线学习";
    }

    // that.appid=JSON.parse(sessionStorage.getItem('subjectChoose')).AppID
    // that.getTeacher();

    // var dataa={
    // 	dls_code:that.slbs
    // }
    // selectAgent(dataa).then(res=>{
    // 	console.log("tttttttttttt",res.data.data)
    // 	that.zaixianlianxi=res.data.data[0].ios_adress
    // })
  },
  methods: {
    //非选择科目后进来的
    notSelectKeMu() {
      let that = this;
      localStorage.setItem("slbs2", this.slbs2);
      var lsdata = {
        agentCode: this.slbs,
        suffix: that.slbs2,
      };
      console.log("开始查找老师", lsdata);
      freeCourse2(lsdata).then((res) => {
        console.log("代理商信息", res.data.data);
        if (res.data.data == null) {
          alert("无法找到代理商信息，请联系管理员");
          return;
        }
        if (that.slbs2 == undefined) {
          localStorage.setItem(
            "lsinfo",
            JSON.stringify(res.data.data.tool_data[0])
          );
          that.wechat = res.data.data.tool_data[0].wx;
          that.ewm = res.data.data.tool_data[0].imgUrl;
          that.phone = res.data.data.tool_data[0].tel;
          that.daili = res.data.data.tool_data[0].contact;

          localStorage.setItem(
            "selectAgent",
            JSON.stringify({
              wechat: that.wechat,
              phone: that.phone,
              daili: that.daili,
              ewm: that.ewm,
            })
          );
          localStorage.setItem(
            "agent",
            JSON.stringify({
              slbs: that.slbs,
              wechat: that.wechat,
              ewm: that.ewm,
            })
          );
          localStorage.setItem("path", JSON.stringify("/" + that.slbs));
        } else {
          if (that.slbs2 == "" || that.slbs2 == null) {
            console.log("sasahahahsa333", that.slbs2);
            localStorage.setItem(
              "lsinfo",
              JSON.stringify(res.data.data.tool_data[0])
            );
            that.wechat = res.data.data.tool_data[0].wx;
            that.ewm = res.data.data.tool_data[0].imgUrl;
            that.phone = res.data.data.tool_data[0].tel;
            that.daili = res.data.data.tool_data[0].contact;
            localStorage.setItem(
              "selectAgent",
              JSON.stringify({
                wechat: that.wechat,
                phone: that.phone,
                daili: that.daili,
                ewm: that.ewm,
              })
            );
            localStorage.setItem(
              "agent",
              JSON.stringify({
                slbs: that.slbs,
                wechat: that.wechat,
                ewm: that.ewm,
              })
            );
            localStorage.setItem("path", JSON.stringify("/" + that.slbs));
          } else {
            for (var i = 0; i < res.data.data.tool_data.length; i++) {
              console.log("sasahahahsa", that.slbs2);
              console.log("sasahahahsa222", res.data.data.tool_data[i].suffix);
              if (that.slbs2 == res.data.data.tool_data[i].suffix) {
                console.log("进去了", res.data.data.tool_data[i]);
                localStorage.setItem(
                  "lsinfo",
                  JSON.stringify(res.data.data.tool_data[i])
                );
                that.wechat = res.data.data.tool_data[i].wx;
                that.ewm = res.data.data.tool_data[i].imgUrl;
                that.phone = res.data.data.tool_data[i].tel;
                that.daili = res.data.data.tool_data[i].contact;
                localStorage.setItem(
                  "selectAgent",
                  JSON.stringify({
                    wechat: that.wechat,
                    phone: that.phone,
                    daili: that.daili,
                    ewm: that.ewm,
                  })
                );
                localStorage.setItem(
                  "agent",
                  JSON.stringify({
                    slbs: that.slbs,
                    wechat: that.wechat,
                    ewm: that.ewm,
                  })
                );
                localStorage.setItem("path", JSON.stringify("/" + that.slbs));
              }
            }
          }
        }
      });
    },

    denglu(data) {
      console.log("ddddd", data);
      that.gengduo = false;
    },
    onSubject(itemqq, AppID) {
      console.log("dddddd", AppID);
      // that.appid=AppID
      sessionStorage.setItem("subjectChoose", itemqq);
      this.subjectChoose = JSON.parse(sessionStorage.getItem("subjectChoose")); //接收选科目传过来值
      this.subjectzz = false;
      that.onSwitchsData();
      that.player.dispose();
    },
    // 切换导航栏
    onSwitchs: function (navItem) {
      console.log("navItem", navItem.id);
      that.switchs = navItem.id;
      console.log(that.switchs);
    },
    onSwitch: function (nav_Item) {
      that.switchd = nav_Item.id;
    },

    onSwitchsData() {
      this.KsbClassID = JSON.parse(
        sessionStorage.getItem("subjectChoose")
      ).KsbClassID;


      
      let data = {
        guid: JSON.parse(localStorage.getItem("loginData"))?JSON.parse(localStorage.getItem("loginData")).guid:'',
        appID: JSON.parse(sessionStorage.getItem("subjectChoose")).AppID,
        type: 1,
        hierarchy: 0,
      };
      videoCatalogue(data).then((res) => {
        if (res.data.status == 200) {
          console.log("9999999999999", res.data.data);
          that.videoList = res.data.data; //列表数据
          for (let m in that.videoList) {
            if (m == 0) {
              that.videoList[m]["open"] = true;
            } else {
              that.videoList[m]["open"] = false;
            }
          }
          console.log("1111111", that.videoList);
          this.bf = res.data.data[0].bookID;
          that.onList(res.data.data[0].bookID, 0);
          let book = {
            bookID: res.data.data[0].bookID,
            guid: JSON.parse(localStorage.getItem("loginData"))? JSON.parse(localStorage.getItem("loginData")).guid:'',
            appID: JSON.parse(sessionStorage.getItem("subjectChoose")).AppID,
            type: 1,
            hierarchy: 1,
          };
          videoCatalogue(book).then((res) => {
            var booklistArray = [];

            console.log("222222", res.data.data.childs);
            // var child=res.data.data.childs
            // for(let i in child){

            // 	for(let a in child[i].names){
            // 		if(index!==0){
            // 			child[i].names[a]['opens']=false
            // 		}else{
            // 			child[i].names[a]['opens']=true
            // 		}

            // 		booklistArray.push(child[i].names[a])
            // 		console.log("555555",booklistArray)
            // 		that.booklistArray=booklistArray
            // 	}
            // }

            // res.data.data.childs[0].names[0]['opens']=true
            console.log("222222", res.data.data.childs[0]);
            // that.onVideourl(res.data.data.childs[0].names[0].id)
          });
        }else{
          alert("获取视频信息失败，视频接口返回信息为："+res.data.msg)
        }
      });
      let teacher = {
        guid: JSON.parse(localStorage.getItem("loginData"))?JSON.parse(localStorage.getItem("loginData")).guid:'',
        appID: JSON.parse(sessionStorage.getItem("subjectChoose")).AppID,
      };
      getteacherlist(teacher).then((res) => {
        console.log("teacher", res.data.data);
        that.teacherList = res.data.data.teacherList;
      });
    },
    onList(bookID, index) {
      that.activet = index;

      for (let f in that.videoList) {
        if (that.videoList[f].bookID == bookID) {
          that.videoList[f].open = true;
        } else {
          that.videoList[f].open = false;
        }
      }
      let book = {
        bookID: bookID,
        guid: JSON.parse(localStorage.getItem("loginData")).guid,
        appID: JSON.parse(sessionStorage.getItem("subjectChoose")).AppID,
        type: 1,
        hierarchy: 1,
      };
      videoCatalogue(book).then((res) => {
        var booklistArray = [];
        console.log("childs数据", res.data.data.childs);
        var child = res.data.data.childs;
        for (let i in child) {
          // console.log("3333333",child[i])
          for (let a in child[i].names) {
            if (
              child[i].names[a].id !==
              JSON.parse(localStorage.getItem("videoID"))
            ) {
              child[i].names[a]["opens"] = false;
            } else {
              child[i].names[a]["opens"] = true;
            }

            booklistArray.push(child[i].names[a]);
            console.log("555555", booklistArray);

            that.booklistArray = booklistArray;
          }
        }
        that.onPlayer(that.booklistArray[0]);
      });
    },
    async onPlayer(items, indexs) {
      console.log("播放列表", items);
      // that.activek=indexs
      if (
        items.type == 1 &&
        JSON.parse(sessionStorage.getItem("username")) == null
      ) {
        that.gengduo = true;
      } else if (
        JSON.parse(sessionStorage.getItem("username")) !== null ||
        items.type == 0
      ) {
        for (let t in that.booklistArray) {
          if (that.booklistArray[t].id == items.id) {
            that.booklistArray[t].opens = true;
          } else {
            that.booklistArray[t].opens = false;
          }
        }
        await that.onVideourl(items.id, items.summary, items.knowledgeText);
        that.knowledgeText = items.knowledgeText;
        console.log("itemsitems", items);
        that.feedbackItem = items;
        if (that.player != undefined) {
          that.player.dispose();
        }
      }

      localStorage.setItem("bookid", items.id);
    },
    onVideourl(videoID, summary, knowledgeText) {
      localStorage.setItem("videoID", videoID);
      var data = {
        appID: JSON.parse(sessionStorage.getItem("subjectChoose")).AppID,
        guid: JSON.parse(localStorage.getItem("loginData")).guid, //用户信息id
        videoID: videoID, //视频列表id
        src: 4, //我也不知道是什么，通过看请求都是1，我也写死一个1
        type: 1, //不是很清楚--后续再改，
        bookID: this.bf,
      };
      videoPlayUrl(data).then((res) => {
        console.log("res.data.data.fileURL", res.data.data.fileURL);
        if (res.data.status == 200) {
          that.onPlay(
            res.data.data.fileUrls[1].fileUrl +
              "?MtsHlsUriToken=" +
              res.data.data.token
          );
        }
      });
    },
    onPlay(URL) {
      console.log("url", URL);
      that.player = new Aliplayer(
        {
          id: "J_prismPlayer",
          width: "100%",
          height: "650px",
          autoplay: true,
          source: URL,
        },
        function (player) {}
      );
      console.log("8888888", that.player);
    },
    // 视频反馈内容
    onTypeList: function (index, id) {
      let typeList = that.typeList;
      //添加选中标识
      typeList[index].open = !typeList[index].open;
      //判断选中把id储存
      if (typeList[index].open == true) {
        that.errorType.push(id);
      } else {
        that.errorType.sort(); //排序
        let indexs = that.errorType.lastIndexOf(id); //从后面开始找，获取位置
        that.errorType.splice(indexs, 1); //删除对应的数字
      }
    },
    //提交反馈
    onSubmit: function () {
      // if (that.errorType.length == 0 || that.feedbackContent == "") {
      //   that.$toast("请输入您要反馈的详细内容或者选择反馈项");
      //   return;
      // }

      let data = {
        appID: JSON.parse(sessionStorage.getItem("subjectChoose")).AppID,
        guid: that.guid, //用户信息id
        bookID: that.feedbackItem.bookID, //列表bookID
        deviceType: 1, //列表videoType
        // chapterID: that.chapterID, //所有列表chapterID
        knowledgeID: that.feedbackItem.id, //列表id
        errorType: JSON.stringify(that.errorType), //反馈问题的编号
        feedbackContent: that.feedbackContent, //反馈内容
        feedbackType: 1,
        videoUrl: that.feedbackItem.summary, //视频summary
        // chapterName: that.chapterName, //父级分类chapterName
        bookName: that.feedbackItem.summary, //选中summary
        feedbacks: "",
      };
      AddNews(data).then((res) => {
        if (res.data.status == 200) {
          this.centerDialogVisible = true;
          console.log("ssssss", res.data.data);
        }
      });
    },
    // 切换科目
    switchSubject() {
      that.subjectzz = true;
    },
    // 跳转至考试宝典
    dowload() {
      if (localStorage.getItem("agent") == "undefined") {
        alert("未找到代理商配置，无法下载，请联系管理员");
        return;
      }
      if (
        JSON.parse(localStorage.getItem("agent")).dls == "888-1" ||
        JSON.parse(localStorage.getItem("agent")).dls == "888-2"
      ) {
        var dataa = {
          dls_code: JSON.parse(localStorage.getItem("agent")).dls,
          wechat: JSON.parse(localStorage.getItem("agent")).wechat,
        };
        selectAgent(dataa).then((res) => {
          console.log("lainxi", res);
          window.open("https://ks.ksbao.com/", "_blank");
        });
      } else if (that.slbs == "100748-1-1" || that.slbs == "100748-1-2") {
        window.open(`https://hzs.ksbao.com/?ac=100748-1`);
      } else if (
        this.slbs == "100176-1" ||
        this.slbs == "101417-1" ||
        this.slbs == "100088-1" ||
        this.slbs == "300128-1" ||
        this.slbs == "100006-1" ||
        this.slbs == "101226-2" ||
        this.slbs == "043129" ||
        this.slbs == "100748-1" ||
        this.slbs == "100052-1" ||
        this.slbs == "075901" ||
        this.slbs == "100079-1" ||
        this.slbs == "300100-1" ||
        this.slbs == "300251-1" ||
        this.slbs == "300112-1" ||
        this.slbs == "100660-2" ||
        this.slbs == "037510" ||
        this.slbs == "300089-1" ||
        this.slbs == "047211" ||
        this.slbs == "059601" ||
        this.slbs == "079108" ||
        this.slbs == "085104" ||
        this.slbs == "055618" ||
        this.slbs == "085201" ||
        this.slbs == "077512" ||
        this.slbs == "300051-1" ||
        this.slbs == "300081-1" ||
        this.slbs == "024009" ||
        this.slbs == "073103" ||
        this.slbs == "045207" ||
        this.slbs == "100888-1" ||
        this.slbs == "100401-1" ||
        this.slbs == "100329-1" ||
        this.slbs == "100889-1" ||
        this.slbs == "043504" ||
        this.slbs == "0209001" ||
        this.slbs == "037509" ||
        this.slbs == "101311-1" ||
        this.slbs == "300115-1" ||
        this.slbs == "300265-1" ||
        this.slbs == "200004-1" ||
        this.slbs == "300239-1" ||
        this.slbs == "300049-1" ||
        this.slbs == "023023" ||
        this.slbs == "020090" ||
        this.slbs == "100647-1" ||
        this.slbs == "100274-1 " ||
        this.slbs == "101312-1" ||
        this.slbs == "100531-1" ||
        this.slbs == "100018-1" ||
        this.slbs == "100033-1" ||
        this.slbs == "100033-2" ||
        this.slbs == "100167-1" ||
        this.slbs == "100016-1" ||
        this.slbs == "100398-1" ||
        this.slbs == "101262-1" ||
        this.slbs == "101270-1" ||
        this.slbs == "100905-1" ||
        this.slbs == "101473-1" ||
        this.slbs == "100915-1" ||
        this.slbs == "101472-1" ||
        this.slbs == "100922-1" ||
        this.slbs == "101480-1" ||
        this.slbs == "101624-1" ||
        this.slbs == "101492-1" ||
        this.slbs == "101466-1" ||
        this.slbs == "101471-1" ||
        this.slbs == "101616-1" ||
        this.slbs == "101620-1" ||
        this.slbs == "101622-1" ||
        this.slbs == "101632-1" ||
        this.slbs == "101628-1" ||
        this.slbs == "668002" ||
        this.slbs == "101485-1" ||
        this.slbs == "101466-2" ||
        this.slbs == "101617-1" ||
        this.slbs == "101618-1" ||
        this.slbs == "020010-1" ||
        this.slbs == "101082-1" ||
        this.slbs == "039406" ||
        this.slbs == "100966-1" ||
        this.slbs == "100898-1 " ||
        this.slbs == "300182-1" ||
        this.slbs == "300116-1" ||
        this.slbs == "300111-1" ||
        this.slbs == "300096-2 " ||
        this.slbs == "07719001" ||
        this.slbs == "04789001" ||
        this.slbs == "0209001" ||
        this.slbs == "03719002" ||
        this.slbs == "05759001" ||
        that.slbs == "100176-1" ||
        that.slbs == "100052-1" ||
        that.slbs == "100006-1" ||
        that.slbs == "100401-1" ||
        that.slbs == "100888-1" ||
        that.slbs == "020087" ||
        this.slbs == "300100-1" ||
        this.slbs == "300112-1" ||
        this.slbs == "100079-1" ||
        this.slbs == "300239-1" ||
        this.slbs == "100660-2" ||
        this.slbs == "037510" ||
        this.slbs == "300128-1" ||
        this.slbs == "300251-1" ||
        this.slbs == "300081-1" ||
        this.slbs == "075901" ||
        this.slbs == "047211" ||
        this.slbs == "059601" ||
        this.slbs == "079108" ||
        this.slbs == "085104" ||
        this.slbs == "055618" ||
        this.slbs == "085201" ||
        (this.slbs == "077512" && this.slbs2 == "1") ||
        this.slbs2 == "2"
      ) {
        window.open(`https://hzs.ksbao.com/?ac=${that.slbs}`);
      } else if (
        this.slbs == "100892-1" ||
        this.slbs == "300256-1" ||
        this.slbs == "300221-1" ||
        this.slbs == "300297-1" ||
        this.slbs == "300265-1" ||
        this.slbs == "300233-1" ||
        this.slbs == "300117-1" ||
        this.slbs == "300218-1" ||
        this.slbs == "300276-1" ||
        this.slbs == "300267-1" ||
        this.slbs == "300143-1" ||
        this.slbs == "300294-1" ||
        this.slbs == "300248-1" ||
        this.slbs == "100031-1" ||
        this.slbs == "300282-1" ||
        this.slbs == "300252-1" ||
        this.slbs == "300166-1" ||
        this.slbs == "300049-1" ||
        this.slbs == "300225-1" ||
        this.slbs == "300255-1" ||
        this.slbs == "300290-1" ||
        this.slbs == "300224-1" ||
        this.slbs == "300235-1" ||
        this.slbs == "300283-1" ||
        this.slbs == "300306-1" ||
        this.slbs == "300231-1" ||
        this.slbs == "300249-1" ||
        this.slbs == "300194-1" ||
        this.slbs == "073122" ||
        this.slbs == "093201" ||
        this.slbs == "300115-1" ||
        this.slbs == "300280-1" ||
        this.slbs == "101311-1" ||
        this.slbs == "300239-1" ||
        this.slbs == "045503" ||
        this.slbs == "076303" ||
        this.slbs == "047803" ||
        this.slbs == "053618" ||
        this.slbs == "031611" ||
        this.slbs == "031611" ||
        this.slbs == "037501" ||
        this.slbs == "035001" ||
        this.slbs == "031605" ||
        this.slbs == "031606" ||
        this.slbs == "031607" ||
        this.slbs == "031608" ||
        this.slbs == "031609" ||
        this.slbs == "031610" ||
        this.slbs == "031611" ||
        this.slbs == "053619" ||
        this.slbs == "037509" ||
        this.slbs == "043504" ||
        this.slbs == "300139-1" ||
        this.slbs == "300102-1" ||
        this.slbs == "100417-1" ||
        this.slbs == "300152-1" ||
        this.slbs == "300125-1" ||
        this.slbs == "300155-1" ||
        this.slbs == "300142-1" ||
        this.slbs == "300149-1" ||
        this.slbs == "300171-1" ||
        this.slbs == "300172-1" ||
        this.slbs == "100535-1" ||
        this.slbs == "300146-1" ||
        this.slbs == "100745-1" ||
        this.slbs == "300104-1" ||
        this.slbs == "031505" ||
        this.slbs == "100183-1" ||
        this.slbs == "300195-1" ||
        this.slbs == "300183-1" ||
        this.slbs == "300117-1" ||
        this.slbs == "300197-1" ||
        this.slbs == "300199-1" ||
        this.slbs == "069202" ||
        this.slbs == "077134" ||
        this.slbs == "057117" ||
        this.slbs == "073305" ||
        this.slbs == "101212-1" ||
        this.slbs == "066203" ||
        this.slbs == "300200-1" ||
        this.slbs == "300202-1" ||
        this.slbs == "300203-1" ||
        this.slbs == "300205-1" ||
        this.slbs == "300206-1" ||
        this.slbs == "300207-1" ||
        this.slbs == "300210-1" ||
        this.slbs == "300213-1" ||
        this.slbs == "300222-1" ||
        this.slbs == "300230-1" ||
        this.slbs == "300232-1" ||
        this.slbs == "300234-1" ||
        this.slbs == "300235-1" ||
        this.slbs == "300236-1" ||
        this.slbs == "300238-1" ||
        this.slbs == "300241-1" ||
        this.slbs == "300264-1" ||
        this.slbs == "6001-5" ||
        this.slbs == "300263-1" ||
        this.slbs == "300293-1" ||
        this.slbs == "300163-1" ||
        this.slbs == "300258-1" ||
        this.slbs == "300291-1" ||
        this.slbs == "300269-1" ||
        this.slbs == "300270-1" ||
        this.slbs == "057119" ||
        this.slbs == "300257-1" ||
        this.slbs == "300244-1" ||
        this.slbs == "043129" ||
        this.slbs == "020010-1" ||
        this.slbs == "057119" ||
        this.slbs == "300191-1" ||
        this.slbs == "300274-1" ||
        this.slbs == "031203" ||
        this.slbs == "037001" ||
        this.slbs == "039101" ||
        this.slbs == "037002" ||
        this.slbs == "079706" ||
        this.slbs == "034901" ||
        this.slbs == "091601" ||
        this.slbs == "043129" ||
        this.slbs == "077403" ||
        this.slbs == "063402" ||
        this.slbs == "075407" ||
        this.slbs == "039203" ||
        this.slbs == "028034" ||
        this.slbs == "059506" ||
        this.slbs == "057504" ||
        this.slbs == "053116" ||
        this.slbs == "024009" ||
        this.slbs == "031701" ||
        this.slbs == "035301" ||
        this.slbs == "035502" ||
        this.slbs == "037601" ||
        this.slbs == "037708" ||
        this.slbs == "039602" ||
        this.slbs == "045207" ||
        this.slbs == "051213" ||
        this.slbs == "051608" ||
        this.slbs == "053115" ||
        this.slbs == "055701" ||
        this.slbs == "073103" ||
        this.slbs == "073125" ||
        this.slbs == "075303" ||
        this.slbs == "075403" ||
        this.slbs == "075512" ||
        this.slbs == "076903" ||
        this.slbs == "077114" ||
        this.slbs == "077201" ||
        this.slbs == "081801" ||
        this.slbs == "083402" ||
        this.slbs == "300302-1" ||
        this.slbs == "029016" ||
        this.slbs == "039305" ||
        this.slbs == "043301" ||
        this.slbs == "045101" ||
        this.slbs == "047210" ||
        this.slbs == "048201" ||
        this.slbs == "055003" ||
        this.slbs == "073604" ||
        this.slbs == "073901" ||
        this.slbs == "079207" ||
        this.slbs == "081306" ||
        this.slbs == "085100" ||
        this.slbs == "089802" ||
        this.slbs == "048203" ||
        this.slbs == "079202" ||
        this.slbs == "045906" ||
        this.slbs == "045403" ||
        this.slbs == "051608" ||
        this.slbs == "099104" ||
        this.slbs == "073004" ||
        this.slbs == "037402" ||
        this.slbs == "051083" ||
        this.slbs == "300295-1" ||
        this.slbs == "028035" ||
        this.slbs == "093603" ||
        this.slbs == "035111" ||
        this.slbs == "073201" ||
        this.slbs == "300299-1" ||
        this.slbs == "087203" ||
        this.slbs == "073301" ||
        this.slbs == "077308" ||
        this.slbs == "037199" ||
        this.slbs == "300226-1" ||
        this.slbs == "057001" ||
        this.slbs == "085206" ||
        this.slbs == "077605" ||
        this.slbs == "099402" ||
        this.slbs == "035106" ||
        this.slbs == "047212" ||
        (this.slbs == "075908" && this.slbs2 == "XSX")
      ) {
        window.open("https://www.ksbao.com/st", "_blank");
      } else if (this.slbs == "101082-1" && this.slbs2 == "xiaohei") {
        window.location.href =
          "http://sp.zhongshicc.com/ewdownload/xiaohei.html";
      } else if(this.slbs =='100521-1'){
        window.location.href ='https://ksbd8.com/getapp'
      } else {
        var dataa = {
          dls_code: JSON.parse(localStorage.getItem("agent")).slbs,
          wechat: JSON.parse(localStorage.getItem("agent")).wechat,
        };
        selectAgent(dataa).then((res) => {
          console.log("lainxi", res);
          if (res.data.data[0].pc_adress == "") {
            window.open("https://ks.ksbao.com/", "_blank");
          } else {
            // 'https://'+
            window.open(res.data.data[0].pc_adress, "_blank");
          }

          // console.log("二维码",that.ewm)
        });
      }
      // window.open('https://ks.ksbao.com/', '_blank');
    },
  },
};
</script>

<style scoped="scoped">
/* .keycaseVideo /deep/ .el-header{
		
	} */
.eerr {
  text-align: center;
}
.yidunde {
  width: 105px;
  margin-right: 10px;
  float: right;
  font-size: 10px;
  margin-top: -38px;
}

.ww {
  width: 100%;
  background: #f2f2f2;
  height: 650px;
  /* display: flex;
		flex-direction: row; */
  /* overflow: hidden; */
}
.keycaseVideo /deep/.el-main {
  background: #f2f2f2;
  margin-top: 10px;
  margin-left: -10px;
  margin-right: -8px;
}
.keycaseVideo .fankui /deep/ .el-dialog__header {
  background: #5bb8ff;
}

.keycaseVideo /deep/ .el-button--primary {
  background-color: #5bb8ff;
  border-color: #5bb8ff;
}
.keycaseVideo /deep/ .fankui .el-icon-close:before {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
}
.keycaseVideo .login /deep/ .el-input__inner {
  /* border: none; */
  /* outline: none; */
}
.keycaseVideo .login /deep/ .el-dialog__header {
  padding: 20px 20px 10px;
}
.keycaseVideo .login /deep/ .el-dialog__title {
  font-weight: 700;
  color: #6ec1fd;
  font-size: 22px;
}
.keycaseVideo .header {
  height: 60px;
  margin: auto;
  /* border: 1px solid #CCCCCC; */
  margin-top: 5px;
}
.header-title {
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 28px;
  font-weight: 600;
  
}
.header .header-title /deep/ span {
  color: #2c3e50 !important;
}
.select-km {
  width: 100px;
  height: 30px;
  /* line-height: 60px; */
  /* vertical-align: top; */
  vertical-align: middle;
  line-height: 60px;
  margin-top: -10px;
  margin-top: 20px;
  /* margin-top: -10px; */
  font-size: 14px;
  font-weight: 500;
  padding: 5px;
  color: #797979;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.video {
  /* width: 800px; */
  width: 65%;
  height: 650px;
  float: left;
  background: #ffffff;
}
.right {
  width: 33%;
  height: 650px;
  float: left;
  margin-left: 2%;
  background: #ffffff;
}
.navList ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 15px;
  height: 40px;
  background: #ffffff;
  margin-top: 10px;
  margin-left: 20px;
  /* border-bottom: 1px solid #EEEEEE; */
}

/* 	ul {
		margin: 0;
		padding: 0;
	} */

.navList ul li {
  display: flex;
  height: 40px;
  width: 100px;
  align-items: center;
  /* flex: 1; */
  /* color: #1a1a1a; */
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 3px;
}

.aaaa {
  color: #3aacff;
  background-color: #cae4ff;
}
.videolist {
  width: 100%;
  height: 600px;
  /* background-color: #CCCCCC; */
  margin-top: 20px;
  margin-left: 10px;
  overflow: hidden;
}
.list-left {
  width: 40%;
  height: 500px;
  float: left;
  /* background-color: #f3f3f3; */
  overflow: auto;
  overflow-x: hidden;
}
.gengduo {
  width: 38%;
  height: 40px;
  margin-top: 510px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-weight: 700;
  color: #6ec1fd;
  font-family: Source Han Sans CN Bold, Source Han Sans CN Bold-Bold;
  cursor: pointer;
  /* border: 1px solid #1A1A1A; */
}
/* .list-mildel{
		width: 30%;
		height: 500px;
		float: left;
		background-color: darkcyan;
	} */
.list-right {
  width: 58%;
  height: 500px;
  float: left;

  /* background-color: yellow; */
  overflow: auto;
  /* margin-left: 20px; */

  overflow-x: hidden;
}
.list-title {
  width: 92%;
  /* height: 46px; */
  background: #f3f3f3;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  /* padding-top: 5px;
		padding-bottom: 5px; */
  font-size: 15px;
  cursor: pointer;
  border-bottom: 1px solid #e9e9e9;
}
.list-kecheng {
  width: 100%;
  /* height: 50px; */
  /* background: yellow; */
  /* line-height: 46px; */

  padding-top: 12px;
  padding-bottom: 10px;
  padding-left: 20px;

  font-size: 14px;
  cursor: pointer;
  /* border-bottom:1px solid #e9e9e9 ; */
}
.title {
  color: #7db8fd;
}
.kecheng {
  color: #7db8fd;
}
.kecheng-mianfei {
  border: 1px solid #7db8fd;
}
.aa {
  border: 1px solid #333333;
}
.mianfei {
  font-size: 13px;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  margin-left: 5px;
}
.knowledgeText {
  width: 95%;
  height: 550px;
  margin: 20px;
  overflow: auto;
}
.footer {
  /* width: 100%; */
  /* height: 500px; */
  margin-top: 20px;
  background-color: #ffffff;
}
.navList-footer ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 15px;
  height: 50px;
  background: #ffffff;
  margin-top: 10px;
  padding-left: 35px;
  border-bottom: 1px solid #eeeeee;
}

ul {
  margin: 0;
  padding: 0;
}

.navList-footer ul li {
  display: flex;
  height: 50px;
  width: 100px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
}
.actived {
  color: #5bb8ff;
  /* background-color: yellow; */
  border-bottom: 1px solid #5bb8ff;
}
.teacher-content {
  padding: 20px 30px;
  border-bottom: 1px solid #eeeeee;
}
.guid-content {
  display: flex;
  flex-direction: row;
}

.guid-content-left-img {
  width: 60px;
  height: 60px;
  border-radius: 60px;
  border: 1px solid #5bb8ff;
}

.guid-content-right-title {
  color: #1a1a1a;
  line-height: 60px;
  font-size: 16px;
  font-weight: 600;
  font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
}

.guid-content-right-text {
  font-size: 16px;
  margin-top: 5px;
  color: #afafaf;
}

.guid-content-right {
  margin-left: 20px;
}
.feedback {
  padding: 20px 20px;
  /* box-sizing: border-box; */
}
.typeList li.ac {
  color: #fff;
  background: #5bb8ff;
  border: 1px solid #5bb8ff;
  cursor: pointer;
}
.typeList ul {
  margin-left: -50px;
}
.typeList li {
  list-style: none;
  float: left;
  color: #6d6d6d;
  border: 1px solid #6d6d6d;
  margin-right: 10px;
  padding: 4px;
  margin-bottom: 10px;
  border-radius: 3px;
  font-size: 15px;
  cursor: pointer;
}
.textarea {
  /* border: none; */
  outline: none;
  width: 100%;
  height: 150px;
  padding: 30px;
  font-size: 16px;
  color: #333333;
  background: #f4f4f4;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.neirong {
  width: 80%;
  height: 60px;
}
.tijiao {
  background-color: #5bb8ff;
  color: #ffffff;
  margin-left: 95%;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 5px;
  font-size: 15px;
}
.zzzzz {
  height: 500px;
}
.dowload {
  font-weight: 500;
  font-size: 18px;
  float: right;
  margin-right: 30px;
  margin-top: 10px;
  margin-bottom: -5px;
  cursor: pointer;
}
.bofang {
  width: 25px;
  height: 25px;
  margin-left: 30%;
  margin-top: -10px;
}
/* .teacher_js{
	   height: 500px;
	   width: 100%;
	   background-color: #0000FF;
   } */
</style>
